module.exports = "https://cdn.realtymogul.com/static/media/icon_download.4db1cbfd.svg";